import { DPDay } from '@rehookify/datepicker';
import styled from 'styled-components';

import { theme } from '../../../common/ui/theme';
import { getWeekNumberForDate } from '../util/getWeekNumberForDate';

interface WeekNumbersProps {
    days: DPDay[];
}

const WeekNumber = styled.div`
    width: 40px;
    height: 40px;
    padding: ${theme.space[8]};
    text-align: center;
    color: ${theme.colors.foreground.subtle};
    font-size: 12px;
    font-weight: ${theme.fontWeights[400]};
    line-height: 24px;
`;

export const WeekNumbers = ({ days }: WeekNumbersProps) => {
    const weekNumbersRequired = Math.ceil(days.length / 7);

    return (
        <div style={{ display: 'flex', flexDirection: 'column' }}>
            <WeekNumber />
            {new Array(weekNumbersRequired).fill(1).map((_, index) => {
                const firstDayOfWeek = days[index * 7];
                const weekNumber = getWeekNumberForDate(firstDayOfWeek.$date);

                return <WeekNumber key={firstDayOfWeek.$date.toISOString()}>{weekNumber}</WeekNumber>;
            })}
        </div>
    );
};
